/** @format */

import React, { useState, useEffect } from "react";
import { NavigateFunction, useNavigate } from "react-router-dom";
import AWS from "aws-sdk";
import jwt_decode from "jwt-decode";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import "./Login.css";
import { getUserDetails } from "../services/auth.service";
import { Col, Row, Card, Image, Button, Form, Input, Spin } from "antd";

type Props = {};

const Login: React.FC<Props> = () => {
  let navigate: NavigateFunction = useNavigate();

  const [loading, setLoading] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [loginVisible, setLoginVisible] = useState(true);

  useEffect(() => {
    if (window.location.hash) {
      setLoginVisible(false);
      console.log(window.location.hash);
      handleLogin(window.location.hash.substring(1));
      // window.location.reload();
    }
    else if(localStorage.getItem("access_token")){
      navigate("/dashboard");
    }
  });
  const handleLogin = (hash: any) => {
    const params: any = {};
    hash.split("&").map((item) => {
      const s = item.split("=");
      params[s[0]] = s[1];
    });
    console.log(params);
    // debugger;
    getUserDetails(params).then(
      (response) => {
        localStorage.setItem("access_token", params.access_token);
        localStorage.setItem("id_token", params.id_token);
        localStorage.setItem(
          "jwt",
          JSON.stringify(jwt_decode(params.access_token))
        );
        setTimeout(() => {
          navigate("/dashboard");
          window.location.reload();
        }, 3000)

      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        setLoading(false);
        setMessage(resMessage);
      }
    );
  };
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 8 },
  };

  const tailLayout = {
    wrapperCol: { offset: 2, span: 20 },
  };

  return (
    <>
     
    {!loginVisible &&  <div className="redirect-body">
        <Spin className="cat-loader-spinner" size="large" />
        <h1>Redirecting...</h1>
      </div>}
    { loginVisible && <Row className='login-page'>
    <Card className='login-card'>
      <h2>URL Recategorization</h2>
      <p>Log in with Single Sign On (SSO) to submit a request to recategorize a URL. </p>
    <Button
                className='login-button'
                type='primary'
                htmlType='button'
                size='large'
                style={{ width: "100%" }}
                onClick={(e) => {
                  window.location.href =
                    "https://urlrecat.auth.us-east-1.amazoncognito.com/oauth2/authorize?client_id=3592ngtbal2vd8cn6sh5d9n3hb&response_type=token&response_mode=fragment&scope=email+openid+phone&redirect_uri=https://urlcat.sase-swg-dev.juniperclouds.net/login";
                }}
              >
                Login with SSO
              </Button>
{/*           <Form {...layout}>
            <Row>
              <Col span='24' style={{ textAlign: "center" }}>


              </Col>
            </Row>
          </Form> */}
        </Card>
    </Row>}
    </>
  );
};

export default Login;
